import React from 'react';
import PropTypes from 'prop-types';
import '../assignments.scss';
import EditActivity from '../EditActivity';
import Modal from '../../../../../components/Modal';

const FlashcardPreviewModal = ({
  isOpen,
  onClose
}) => {
  return (
    <Modal
      isOpen={isOpen}
      titleName="Flashcard Preview"
      onClose={() => onClose() }
      contentWidth="100%">
      <>
        <EditActivity
          isPreview={true}
        />
      </>
    </Modal>      
  );
};

FlashcardPreviewModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default FlashcardPreviewModal;
